<template>
  <!-- 直播视频 组件 -->
  <div
    ref="box"
    @mouseover="showTool = true"
    @mouseout="showTool = false"
    class="video-box newGif"
    :id="id_serialNumber"
  >
    <!-- 视频播放源 -->
    <!-- <video
      ref="video"
      @timeupdate="timeupdate"
      poster="../../../icon/real-video/video-loding.gif"
      autoplay
      preload="auto"
      :muted="muted"
    ></video> -->
    <!-- 顶部控制栏 -->
    <div v-show="showTool" class="monitor_topbar">
      <div class="topbar_left">
        <span v-if="device" class="left userName">{{ device.name }}</span>
        <img class="net_type" :title="getSignTitle" v-if="helmetStatus" :src="getSign" />
      </div>
      <div class="topbar_mid" v-show="!toolClick">
        <!-- 拍照 -->
        <img v-if="helmetStatus && helmetStatus.photo === '1'" src="@/icon/real-video/photo-on.png" />
        <img v-else :title="$t('拍照')" src="@/icon/real-video/photo.png" @click="switchAction(ACTION.PHOTO_OPEN)" />
        <!-- GPS -->
        <img
          v-if="helmetStatus == null || helmetStatus.GPS === '0'"
          :title="$t('GPS_BD')"
          src="@/icon/real-video/gps.png"
          @click="switchAction(ACTION.GPS_OPEN)"
        />
        <img v-else :title="$t('GPS_BD')" src="@/icon/real-video/gps-on.png" @click="switchAction(ACTION.GPS_CLOSE)" />
        <!-- LED 照明 -->
        <img
          v-if="helmetStatus == null || helmetStatus.LED === '0'"
          title="LED"
          src="@/icon/real-video/led.png"
          @click="switchAction(ACTION.LED_OPEN)"
        />
        <img v-else title="LED" src="@/icon/real-video/led-on.png" @click="switchAction(ACTION.LED_CLOSE)" />
        <!-- 激光 -->
        <img
          v-if="helmetStatus == null || helmetStatus.laser === '0'"
          :title="$t('laser')"
          src="@/icon/real-video/laser.png"
          @click="switchAction(ACTION.LASER_OPEN)"
        />
        <img v-else :title="$t('laser')" src="@/icon/real-video/laser-on.png" @click="switchAction(ACTION.LASER_CLOSE)" />
        <!-- 警示灯 -->
        <img
          v-if="helmetStatus == null || helmetStatus.warnlight === '0'"
          :title="$t('WarningLight')"
          src="@/icon/real-video/warningLed.png"
          @click="switchAction(ACTION.WARNLIGHT_OPEN)"
        />
        <img
          v-else
          :title="$t('WarningLight')"
          src="@/icon/real-video/warningLed-on.png"
          @click="switchAction(ACTION.WARNLIGHT_CLOSE)"
        />
        <!-- 设备类型为 国标智能安全帽 时屏蔽切换实时视频模式 -->
        <img
          v-if="device.specType !== 3"
          :title="$t('switchrealtimevideo')"
          src="@/icon/real-video/video.png"
          @click="openRealvideo"
        />
      </div>
      <div class="topbar_right">
        <div class="left definit" v-show="!this.device.safetyHelmet">
          <div class="resolution-video" @click="showList">
            {{ currentDefinit }}
          </div>
          <div class="resolut-list" v-if="definitShow">
            <ul>
              <li v-for="item in definition" :key="item.value" @click="switchResolutionP(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <img class="close" src="@/icon/real-video/close.png" @click="close" />
      </div>
    </div>
    <!-- 底部控制栏 -->
    <div v-show="showTool" class="video_controller">
      <img v-if="isVideoPlay" class="video_pause" src="@/icon/real-video/video-pause.png" @click="switchVideoPlay" />
      <img v-else class="video_pause" src="@/icon/real-video/video-play.png" @click="switchVideoPlay" />
      <img class="video_flash" src="@/icon/real-video/video-flash.png" @click="reflashVideoPlay" />
      <div class="progress_time">
        <progress value="100" max="100" class="video_progress"></progress>
        <span class="video_time">{{ playedTime }}</span>
      </div>
      <img v-if="muted" class="video_volume" src="@/icon/real-video/volume-off.png" @click="switchMuted" />
      <img v-else class="video_volume" src="@/icon/real-video/volume-up.png" @click="switchMuted" />
      <img class="full_btn" src="@/icon/real-video/fullscreen.png" @click="switchFullScreen" />
    </div>
  </div>
</template>

<script>
import { PrefixInteger } from '@/api/common'
import { sendLiveUrlRequest, sendLiveRequestInterval } from '@/common/websocket/live'
import { alertWin } from '@/util/common'

import { ACTION, initSwitch, switchAction } from '@/common/websocket/remoteControl'
import { videoSignal } from '@/util/networkSignal'
export default {
  name: 'LiveVideo',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /**
     * 设备信息 {"name":"直播用户名","serialNumber":"安全帽序列号","liveUrl":"直播地址","resolutionP":直播清晰度,"userId":"用户id","specType":2}
     */
    device: {
      type: Object,
    },
    ipcVideo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 设置id为唯一序列号
      id_serialNumber: null,
      // 播放器
      flvPlayer: null,
      // 播放器播放时间
      playedTime: '00:00:00',
      // 展示工具栏
      showTool: false,
      // 展示的播放状态，不代表视频真的在播放，video.paused可以获取真实的状态
      isVideoPlay: true,
      // 是否静音
      muted: true,
      // 是否全屏
      isFullScreen: false,
      ACTION,
      definitShow: false,
      currentDefinit: this.$t('highDefinition'),
      definition: [
        { value: 12, label: this.$t('standardDefinition') },
        { value: 14, label: this.$t('highDefinition') },
        { value: 16, label: this.$t('ultraclear') },
      ],
      player: null,
      // 定时发送直播ws
      liveInterval: null,
      wrongTip: null,
    }
  },
  computed: {
    // toolClick true:执法仪，false：管控3 用于视频工具栏是否显示
    toolClick() {
      return this.device.specType === 2 ? true : false
    },
    helmetStatus() {
      return this.$store.state.helmetStatusObj[this.device.serialNumber]
    },
    getSign() {
      if (
        this.helmetStatus.WIFI !== '0' &&
        this.helmetStatus.WIFI !== '-2' &&
        this.helmetStatus.WIFI !== '-1' &&
        this.helmetStatus.WIFI !== '-3'
      ) {
        switch (this.helmetStatus.WIFI) {
          case '1':
            return require('@/icon/real-video/wifi1.png')
          case '2':
            return require('@/icon/real-video/wifi2.png')
          case '3':
            return require('@/icon/real-video/wifi3.png')
          case '4':
            return require('@/icon/real-video/wifi4.png')
          default:
            return require('@/icon/real-video/wifi4.png')
        }
      } else if (this.helmetStatus.phoneSign !== '0' && this.helmetStatus.networkSignal) {
        if (this.device && this.device.serialNumber && this.device.serialNumber.indexOf('HWIH07') > -1) {
          return videoSignal('5', this.helmetStatus.networkSignal)
        } else {
          switch (this.helmetStatus.phoneSign) {
            case '2':
              return videoSignal('2', this.helmetStatus.networkSignal)
            case '3':
              return videoSignal('3', this.helmetStatus.networkSignal)
            case '4':
              return videoSignal('4', this.helmetStatus.networkSignal)
            default:
              return require('@/icon/real-video/4g.png')
          }
        }
      } else {
        return require('@/icon/real-video/no-sign.png')
      }
    },

    getSignTitle() {
      if (this.helmetStatus.WIFI !== '0') {
        return 'wifi'
      } else if (this.helmetStatus.phoneSign !== '0') {

        return 'mobile'
      } else {
        return ''
      }
    },
  },
  methods: {
    // 打开实时视频
    openRealvideo() {
      this.$emit('handleVideo', this.device)
      clearTimeout(this.wrongTip)
    },
    // 关闭提示
    clearSetTimeout() {
      clearTimeout(this.wrongTip)
    },
    // 播放视频:使用flv.js播放直播流
    playVideo() {
      // 使用TcPlayer播放直播流
      let that = this
      this.player = new TcPlayer(this.id_serialNumber, {
        flv: this.device.liveUrl, //增加了一个 flv 的播放地址，用于PC平台的播放 请替换成实际可用的播放地址
        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        poster: {
          style: 'stretch',
          src: require('../../../icon/real-video/video-loding.gif'),
        },
        width: '100%', //视频的显示宽度，请尽量使用视频分辨率宽度
        height: '100%', //视频的显示高度，请尽量使用视频分辨率高度
        controls: 'none',
        h5_flv: true,
        // 监听事件
        listener: msg => {
          switch (msg.type) {
            case 'load':
              // 默认禁音
              this.player.mute(true)
              break
            case 'timeupdate':
              // 监听timeupdate事件
              let Element = document.getElementById(this.device.serialNumber)
              let videoElement = Element.getElementsByTagName('video')[0]
              videoElement.style.objectFit = 'fill'
              this.device.serialNumber = this.device.serialNumber + ''
              if (this.device.serialNumber && this.device.serialNumber.indexOf('HWIH0301') !== -1) {
                // videoElement.style.transform = 'rotate(-180deg)'
              }
              let time = videoElement.currentTime
              var hour = Math.floor(time / 3600)
              var minute = Math.floor((time % 3600) / 60)
              var second = Math.floor(time % 60)
              this.playedTime = PrefixInteger(hour, 2) + ':' + PrefixInteger(minute, 2) + ':' + PrefixInteger(second, 2)
              // console.log('timeupdate', this.playedTime)
              break
            case 'ended':
              // 监听安全帽监控退出事件
              // 抢占时掉线不处理
              if (this.$store.state.isPreempt) {
                this.$store.commit('handleIsPreempt', false)
                return
              }
              this.wrongTip = setTimeout(() => {
                alertWin('安全帽已掉线，无法自动重连，自动退出视频监控', that.close)
              }, 10000)
              break
            case 'error':
              // 异常情况进行重连
              setTimeout(() => {
                this.player.load()
              }, 3000)
              break
            case 'pause':
              // 暂停事件
              this.isVideoPlay = false
              break
            case 'play':
              // 播放
              this.isVideoPlay = true
              if (this.ipcVideo) {
                this.switchMuted()
              }
              break
            case 'playing':
              break
            default:
            // 其它未处理事件：progress、playing
          }
        },
        on: val=>{
          console.log(val, '获取播放 webrtc 过程中的所有事件')
        }
      })
    },
    // 关闭窗口
    close() {
      this.$emit('close', this.device.serialNumber,this.device)
      this.device.serialNumber = ''
      // 关闭定时器
      if (!this.device.safetyHelmet) {
        clearInterval(this.liveInterval)
      }
    },
    // 切换全屏状态
    switchFullScreen() {
      this.isFullScreen = !this.isFullScreen
      if (this.isFullScreen) {
        // 全屏
        if (document.documentElement.webkitRequestFullScreen) {
          this.$refs.box.webkitRequestFullScreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          this.$refs.box.mozRequestFullScreen()
        } else if (document.documentElement.msRequestFullScreen) {
          this.$refs.box.msRequestFullScreen()
        }
      } else {
        // 退出全屏
        if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
    // 切换视频播放状态
    switchVideoPlay() {
      this.isVideoPlay = !this.isVideoPlay
      if (this.isVideoPlay) {
        // 播放中
        this.player.play()
      } else {
        // this.$refs.video.pause()
        this.player.pause()
      }
    },
    // 刷新视频
    reflashVideoPlay() {
      if (this.player) {
        this.player.load()
      }
    },
    // 切换静音状态
    switchMuted() {
      this.muted = !this.muted
      if (this.player) {
        if (this.muted) {
          this.player.volume(0)
        } else {
          this.player.volume(1)
        }
      }
    },
    // 视频播放时间更新
    // timeupdate() {
    //   if (this.$refs.video) {
    //     let time = this.$refs.video.currentTime
    //     var hour = Math.floor(time / 3600)
    //     var minute = Math.floor((time % 3600) / 60)
    //     var second = Math.floor(time % 60)
    //     this.playedTime =
    //       PrefixInteger(hour, 2) +
    //       ':' +
    //       PrefixInteger(minute, 2) +
    //       ':' +
    //       PrefixInteger(second, 2)
    //   }
    // },
    // 遥控器指令
    switchAction(action) {
      switchAction(this.device.serialNumber, action, this.device.userId, this.device.name)
    },
    showList() {
      this.definitShow = true
    },
    // 切换分辨率
    switchResolutionP(item) {
      console.log(item, 'a')
      this.definitShow = false
      this.currentDefinit = item.label
      sendLiveUrlRequest(this.device.serialNumber, item.value)
    },
    // 非当前用户切换分辨率
    changeReaolution(resolution) {
      console.log(resolution)
      if (resolution === 12) {
        this.currentDefinit = this.$t('standardDefinition')
      } else if (resolution === 14) {
        this.currentDefinit = this.$t('highDefinition')
      } else if (resolution === 16) {
        this.currentDefinit = this.$t('ultraclear')
      }
    },
    // 销毁资源
    destroy() {
      // 销毁播放器
      if (this.player) {
        this.player.destroy()
      }
      if (this.ipcVideo) {
        this.muted = true
      }
    },
  },
  mounted() {
    initSwitch(this.device.serialNumber)
    // 设置id为唯一序列号
    console.log('唯一序列号',this.device)
    this.id_serialNumber = this.device.serialNumber + ''
    setTimeout(() => {
      if(this.device.liveUrl && this.device.safetyHelmet) {
        this.playVideo()
      }
      
    }, 1000);
    
    clearInterval(this.liveInterval)
    // 定时发送直播状态
    sendLiveRequestInterval(this.device.serialNumber)
    this.liveInterval = setInterval(() => {
      sendLiveRequestInterval(this.device.serialNumber)
    }, 10 * 1000)
  },
  watch: {
    'device.liveUrl'(oldVal,val) {
      console.log('监听到直播地址变化',oldVal,val)
      if (oldVal) {
        // 当已有视频播放时，先销毁原来的，然后重新播放
        this.destroy()
      }
      this.playVideo()
    },
  },
  beforeDestroy() {
    // 销毁播放器
    this.destroy()
    clearInterval(this.liveInterval)
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.newGif
  bg-image('~@/icon/real-video/video-loding.gif')
video
  -webkit-transform rotate(-180deg)
.video-box
  position relative
  height 100%
  video
    object-fit fill
    width 100%
    height 100%
    -webkit-transform rotate(-180deg)
  .monitor_topbar
    opacity 1
    position absolute
    top 0
    left 0
    background-color rgba(0, 0, 0, 0.5)
    width 100%
    height 32px
    z-index 1000
    color #fff
    letter-spacing 1px
  .monitor_topbar:hover
    opacity 1
  .topbar_left
    float left
    width 22%
    padding 0 10px
    line-height 32px
    .userName
      width calc(100% - 21px)
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .net_type
      width 17px
      height 17px
      padding-top 6px
      padding-left 4px
  .topbar_mid
    position absolute
    left 50%
    top -2px
    transform translate(-50%, 0)
    cursor pointer
    height 32px
    display flex
    justify-content center
    align-content center
    img
      height 17px
      margin-top 8px
      padding 0 10px
      float left
      text-align center
      line-height 32px
      border-right 1px solid #888
  .topbar_right
    float right
    padding 0px 6px
    .definit
      position relative
      margin-right 10px
      .resolut-list
        position absolute
        top 32px
        left 50%
        transform translate(-50%, 0)
        min-width: 50px;
        ul
          background-color rgba(0, 0, 0, 0.5)
          color #fff
          text-align center
          li
            width 100%
            padding 0 5px
            line-height 28px /* no */
    .resolution-video
      float left
      margin-right 5px
      cursor pointer
      color #fff
      line-height 32px
    .close
      width 17px
      height 17px
      margin-top 8px
      cursor pointer
.video_controller
  position absolute
  bottom 0
  left 0
  background-color rgba(0, 0, 0, 0.5)
  width 100%
  height 33px
  line-height 33px
  z-index 1000
  color #fff
  letter-spacing 1px
  .video_pause
    width 23px
    height 23px
    float left
    left 10px
    top 5px
    position absolute
    cursor pointer
  .video_flash
    width 23px
    height 23px
    float left
    left 38px
    top 5px
    position absolute
    cursor pointer
  .progress_time
    width calc(100% - 135px)
    position absolute
    left 70px
    top 0px
  .video_progress
    height 3px
    width calc(100% - 60px) /* no */
    float right
    display inline
    margin-top 15px
  .video_time
    font-size 12px
    color white
    width 60px /* no */
    margin-top 0px
    float left
  .video_volume
    cursor pointer
    width 23px
    height 23px
    position absolute
    right 38px
    top 5px
  .full_btn
    width 30px
    height 30px
    position absolute
    right 5px
    top 3px
    cursor pointer
    bottom 26px
.newGif ::v-deep .vcp-player
  bg-image('~@/icon/real-video/video-loding.gif')
</style>
